import { render, staticRenderFns } from "./BatchSettings.vue?vue&type=template&id=9d89f264&scoped=true"
import script from "./BatchSettings.vue?vue&type=script&lang=js"
export * from "./BatchSettings.vue?vue&type=script&lang=js"
import style0 from "./BatchSettings.vue?vue&type=style&index=0&id=9d89f264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d89f264",
  null
  
)

export default component.exports